var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeovarsityManagementTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4118 3.89706C19.7794 3.70098 20.2206 3.70098 20.5882 3.89706L39.3382 13.8971C39.7456 14.1143 40 14.5384 40 15C40 15.4616 39.7456 15.8857 39.3382 16.1029L20.5882 26.1029C20.2206 26.299 19.7794 26.299 19.4118 26.1029L0.661765 16.1029C0.254435 15.8857 0 15.4616 0 15C0 14.5384 0.254435 14.1143 0.661765 13.8971L19.4118 3.89706ZM3.90625 15L20 23.5833L36.0938 15L20 6.41667L3.90625 15Z",
    fill: "#0080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8971 14.4118C19.222 13.8026 19.9791 13.5722 20.5883 13.8971L29.9633 18.8971C30.3706 19.1143 30.625 19.5384 30.625 20V37.5C30.625 38.1904 30.0654 38.75 29.375 38.75C28.6847 38.75 28.125 38.1904 28.125 37.5V20.75L19.4118 16.103C18.8026 15.7781 18.5722 15.0209 18.8971 14.4118Z",
    fill: "#0080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62501 16.0781C6.31537 16.0781 6.87501 16.6378 6.87501 17.3281V25.8437L6.87775 25.8472C7.80476 27.0925 11.915 31.875 20 31.875C28.085 31.875 32.1953 27.0925 33.1223 25.8473L33.125 25.8437V17.3281C33.125 16.6378 33.6847 16.0781 34.375 16.0781C35.0654 16.0781 35.625 16.6378 35.625 17.3281V25.8594L35.625 25.8646C35.6227 26.3996 35.4468 26.9192 35.1238 27.3454C33.9503 28.9196 29.186 34.375 20 34.375C10.814 34.375 6.04964 28.9195 4.87623 27.3454C4.55322 26.9192 4.37728 26.3996 4.37502 25.8646L4.375 25.8594L4.37501 17.3281C4.37501 16.6378 4.93466 16.0781 5.62501 16.0781Z",
    fill: "#0080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeovarsityManagementTool);
export default __webpack_public_path__ + "static/media/neovarsityManagementTool.ccea7af53b9827b3aa7b31ec449702c4.svg";
export { ForwardRef as ReactComponent };